import React from 'react'
import { Route, Routes } from 'react-router-dom'
import WhatsappPage from '../../pages/features/whatsapp/WhatsappPage'

export default function WhatsappNav() {
  return (
    <Routes>
             <Route path="/" element={<WhatsappPage />} />
       
           </Routes>
  )
}
